<ng-template #modal let-c="close" let-d="dismiss">
  <ngx-loading [show]="isProcessing"></ngx-loading>
  <div class="modal-header mh-blue">
    <h4 class="modal-title">Detalhes - OS Nº<b><span class="pl-1">{{ OS?.osId | zerosEsquerda : 5 }}</span></b>
    </h4>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="col-md-12">
        <div class="h700" style="overflow-y: scroll;">

          <table class="table tb-detalhes">
            <thead style="border-collapse:collapse; border-spacing: 0">
              <td style="width: 20%"></td>
              <td style="width: 30%"></td>
              <td style="width: 20%"></td>
              <td style="width: 25%"></td>
              <td style="width: 5%"></td>
            </thead>

            <tbody>
              <tr>
                <td colspan="5" style="background-color: #3c5979; padding: 1px"></td>
              </tr>
              <tr>
                <th colspan="5" class="text-center title">Cadastro</th>
              </tr>
              <tr>
                <td colspan="5" style="border:hidden; padding: 7px;"></td>
              </tr>

              <tr>
                <th>Data Hora do Cadastro</th>
                <td>
                  {{OS?.spvCompleto.dataHoraCadastro | date:'dd/MM/yyyy HH:mm'}}
                </td>
                <th>Usuário Solicitante</th>
                <td colspan="2">
                  {{OS?.spvCompleto.usuarioSolicitante}}
                </td>
              </tr>

              <tr>
                <th>Requisitante</th>
                <td>
                  {{OS?.spvCompleto.requisitante}}
                </td>
                <th>Ramal</th>
                <td colspan="2">
                  {{OS?.spvCompleto.contato}}
                </td>
              </tr>

              <tr>
                <th>Serviço</th>
                <td colspan="4">
                  {{OS?.spvCompleto.servico}}
                </td>
              </tr>
              <tr></tr>
              <tr>
                <th>Status Atual</th>
                <td>
                  {{OS?.spvCompleto.statusStr}}
                </td>

                <th>Data Status</th>
                <td colspan="2">{{OS?.spvCompleto.dataStatus | date: "dd/MM/yyyy HH:mm"}}</td>
              </tr>
              <tr>
                <th>{{labelCentroCusto}}</th>
                <td colspan="4">
                  {{OS?.spvCompleto.centroCusto}}
                </td>
              </tr>


              <tr>
                <td colspan="5" style="background-color: #3c5979; padding: 1px;"></td>
              </tr>

              <tr *ngIf="OS?.spvCompleto.spvAprovadoId != null">
                <th colspan="5" class="text-center title">Aprovação/Qualificação</th>
              </tr>
              <tr>
                <td colspan="5" style="border:hidden; padding: 7px;"></td>
              </tr>
              <tr *ngIf="OS?.spvCompleto.spvAprovadoId != null">
                <th>Data Aprovação</th>
                <td>
                  {{OS?.spvCompleto.dataHoraAprovacao | date:'dd/MM/yyyy'}}
                </td>
                <th>Aprovado por</th>
                <td colspan="2">
                  {{OS?.spvCompleto.aprovadoPor}}
                </td>
              </tr>
              <tr *ngIf="OS?.spvCompleto.spvAprovadoId != null">
                <th>Qualificado por</th>
                <td>
                  {{OS?.spvCompleto.qualificadoPor}}
                </td>
                <th>Prioridade</th>
                <td colspan="2">
                  {{OS?.spvCompleto.prioridadeStr}}
                </td>
              </tr>
              <tr *ngIf="OS?.spvCompleto.ptId != null">
                <th>Data Aprovação</th>
                <td>
                  {{OS?.spvCompleto.dataHoraAprovacao | date:'dd/MM/yyyy'}}
                </td>
                <th>Prioridade</th>
                <td colspan="2">
                  {{OS?.spvCompleto.prioridadeStr}}
                </td>
              </tr>
              <tr>
                <th>Observações Gerais</th>
                <td colspan="4">
                  {{OS?.spvCompleto.observacoesGerais}}
                </td>
              </tr>
              <tr>
                <th>Área restrita</th>
                <td>
                  {{OS?.spvCompleto.areaRestritaStr}}
                </td>
                <th>Fim de Semana</th>
                <td colspan="2">
                  {{OS?.spvCompleto.fimDeSemanaStr}}
                </td>
              </tr>
              <tr>
                <th>Engenheiro Responsável</th>
                <td>
                  {{OS?.spvCompleto.engenheiroResponsavel == '' ? ' - ' : OS?.spvCompleto.engenheiroResponsavel}}
                </td>
                <th>Responsável OS</th>
                <td colspan="2">
                  {{OS?.spvCompleto.encarregadoResponsavel == null ? ' - ' : OS?.spvCompleto.encarregadoResponsavel}}
                </td>
              </tr>


              <tr>
                <th>Área Técnica</th>
                <td>
                  {{OS?.spvCompleto.areaTecnica}}
                </td>
                <th>Local</th>
                <td colspan="2">
                  {{OS?.spvCompleto.localStr}}
                </td>
              </tr>

              <tr>
                <th>Equipamento</th>
                <td>
                  {{OS?.spvCompleto.equipamento}}
                </td>
                <th>Empreiteira</th>
                <td colspan="3">
                  {{OS?.spvCompleto.empreiteira}}
                </td>
              </tr>


              <tr>
                <td colspan="5" style="background-color: #3c5979; padding: 1px"></td>
              </tr>
              <tr>
                <th colspan="5" class="text-center title ">Colaboradores</th>
              </tr>
              <tr>
                <td colspan="5" style="border:hidden; padding: 7px;"></td>
              </tr>

              <tr *ngFor="let c of OS?.spvCompleto.colaboradores">
                <td colspan="2" class="text-center">{{ c?.nome }}</td>
                <td colspan="3" class="text-center">{{c?.matricula}}</td>
              </tr>
              <tr *ngIf="OS?.spvCompleto.colaboradores?.length == 0">
                <th colspan="5" class="text-center">Não informado</th>
              </tr>

            </tbody>
          </table>

          <table class="table tb-detalhes" *ngIf="this.showIrregularidades">
            <tbody>

              <tr>
                <td colspan="5" style="background-color: #3c5979; padding: 1px"></td>
              </tr>
              <tr *ngIf="!this.modoEdicao || this.OS.status != 3">
                <th colspan="5" class="text-center title">Irregularidades</th>
              </tr>

              <tr>
                <td colspan="5" style="border:hidden; padding: 7px;"></td>
              </tr>

              <tr>
                <th class="text-center">Tipo Irregularidade</th>
                <th colspan="4" class="text-center">Descrição</th>
              </tr>

              <tr *ngFor="let i of OS.irregularidades">
                <td>{{ i.tipoIrregularidade }}</td>
                <td colspan="4">{{ i.descricao }}</td>

              </tr>
              <tr *ngIf="OS?.irregularidades.length == 0">
                <th colspan="5" class="text-center">Não informado</th>
              </tr>


            </tbody>
          </table>

          <table class="table tb-detalhes" *ngIf="this.showMateriais">
            <tbody>
              <tr>
                <td colspan="5" style="background-color: #3c5979; padding: 1px"></td>
              </tr>
              <tr *ngIf="!this.modoEdicao || this.OS.status != 3">
                <th colspan="5" class="text-center title">Materiais</th>
              </tr>

              <tr>
                <td colspan="5" style="border:hidden; padding: 7px;"></td>
              </tr>



              <tr>
                <th class="text-center">Código</th>
                <th colspan="2" class="text-center">Material</th>
                <th class="text-center">Quantidade</th>
                <th class="text-center">Unidade</th>
              </tr>

              <tr *ngFor="let item of OS.materiaisUsado">
                <td class="text-center">{{ item.codigo }}</td>
                <td colspan="2">{{ item.descricao }}</td>
                <td class="text-center">{{ item.quantidade }}</td>
                <td class="text-center">{{ item.unidade }}</td>

              </tr>
              <tr *ngIf="OS?.materiaisUsado.length == 0">
                <th colspan="5" class="text-center">Não informado</th>
              </tr>
            </tbody>
          </table>

          <table class="table tb-detalhes" *ngIf="this.showDadosRealizacao">
            <tbody>

              <tr>
                <td colspan="5" style="background-color: #3c5979; padding: 1px"></td>
              </tr>
              <tr>
                <th colspan="5" class="text-center title">Dados da realização</th>
              </tr>
              <tr>
                <td colspan="5" style="border:hidden; padding: 7px;"></td>
              </tr>
              <tr>
                <th>Data/Hora Inicio</th>
                <td class="sem-borda">
                  {{OS?.dataHoraInicioExec | date:'dd/MM/yyyy HH:mm'}}
                </td>
                <th class="sem-borda">Data/Hora Fim</th>
                <td colspan="2">
                  {{OS?.dataHoraFimExec | date:'dd/MM/yyyy HH:mm'}}
                </td>
              </tr>
              <tr>
                <th>Cliente</th>
                <td class="sem-borda">
                  {{OS?.cliente }}
                </td>
                <th>Matrícula</th>
                <td colspan="2">
                  {{OS?.matricula}}
                </td>
              </tr>
              <tr>
                <th>Setor</th>
                <td>
                  {{OS?.setor}}
                </td>
                <th class="sem-borda">Satisfeito</th>
                <td *ngIf="OS?.cliente || OS?.matricula">
                  {{this.valores_satisfacao[OS?.satisfeito]}}
                </td>
                <td class="sem-borda text-center" *ngIf="OS?.cliente || OS?.matricula">
                  <img src="./assets/images/{{imagens_satisfacao[OS?.satisfeito]}}" style="width: 20%" />
                </td>
              </tr>

              <tr>
                <th>Serviço Realizado</th>
                <td colspan="4">
                  {{OS?.servicoRealizado}}
                </td>
              </tr>


            </tbody>

          </table>

          <!--  Registros fotográficos (ANTES)-->
          <section style="border-top: 2px solid #3c5979; margin-top: 15px;" *ngIf="this.showRegistroFotografico">
            <div class="form-row text-center" style="padding: 0 5px;">
              <div class="col-md-12 fb fs11" style="background-color: #eee; padding: 12px">
                <span class="txt-blue">
                  Registro fotográfico (Antes)
                </span>
              </div>
            </div>

            <div class="row showImagens" *ngIf="previewsPhotosAntes?.length > 0"
              style="padding-bottom: 20px; min-height: 100px;">
              <div class="col-md-2" *ngFor="let pview of previewsPhotosAntes">
                <div>
                  <img [src]="pview.dataUrl" class="zoom">
                </div>
              </div>
            </div>

            <div *ngIf="previewsPhotosAntes?.length == 0" class="text-center"
              style="margin-top: 50px; margin-bottom: 50px;">
              <span>Nenhum registro fotográfico antes</span>
            </div>
          </section>


          <!--  Registros fotográficos (DEPOIS)-->

          <section style="border-top: 2px solid #3c5979; margin-top: 15px;" *ngIf="this.OS.status == 3">

            <div class="form-row text-center" style="padding: 0 5px;">
              <div class="fb fs11" style="background-color: #eee; padding: 12px"
                [ngClass]="{'col-md-11': this.modoEdicao, 'col-md-12': !this.modoEdicao}">
                <span class="txt-blue">
                  Registro fotográfico (Depois)
                </span>
              </div>
            </div>

            <div class="row showImagens" style="padding-bottom: 20px; min-height: 100px;">
              <div class="col-md-2" *ngFor="let pview of previewsPhotos">
                <div>
                  <img [src]="pview.dataUrl" class="zoom">
                </div>
              </div>
            </div>
            <div *ngIf="previewsPhotos?.length == 0" class="text-center" style="margin-top: 50px; margin-bottom: 50px;">
              <span>Nenhum registro fotográfico depois</span>
            </div>

          </section>


        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">

    <div class="offset-md-1 col-md-4" *ngIf="this.showButtonImprimirOSComEvidenciaFotos">
      <div class="d-flex justify-content-start">
        <button type="button" class="btn btn-secondary btn-block" (click)="reimprimirOS(true)">
          <span class="fa fa-print fa-pull-left pt-1"></span>
          Imprimir OS - com evidência de fotos<span class="pr-3"></span>
        </button>
      </div>
    </div>

    <div class="col-md-4" *ngIf="this.showButtonImprimirOSSemEvidenciaFotos">
      <div class="d-flex justify-content-start">
        <button type="button" class="btn btn-secondary btn-block" (click)="reimprimirOS(false)">
          <span class="fa fa-print fa-pull-left pt-1"></span>
          Imprimir OS - sem evidência de fotos<span class="pr-3"></span>
        </button>
      </div>
    </div>

    <!-- ------------------------------------------------------------------------ -->

    <div class="col-md-4" *ngIf="this.showButtonCancelarOS">
      <div class="d-flex justify-content-start">
        <button type="button" class="btn btn-danger btn-block" (click)="cancelarOSEmitter(this.OS.id)">
          <span class="fa fa-print fa-pull-left pt-1"></span>
          Cancelar OS<span class="pr-3"></span>
        </button>
      </div>
    </div>

    <div class="offset-md-1 col-md-4" *ngIf="this.showButtonLiberarOSParaExecucao">
      <div class="d-flex justify-content-start">
        <button type="button" class="btn btn-info btn-block" (click)="qualificarOSEmitter(this.OS.id)">
          <span class="fa fa-print fa-pull-left pt-1"></span>
          Liberar a OS para execução<span class="pr-3"></span>
        </button>
      </div>
    </div>




    <div class="col-md-1"></div>

    <div class="col-md-2">
      <div class="d-flex justify-content-end">
        <button type="button" class="btn btn-primary btn-block"
          (click)="fecharModal()">{{this.msgButtonFechar}}</button>
      </div>
    </div>

  </div>
</ng-template>